import React, { useState, useEffect } from 'react';
import './DateCountdown.css';
import { DateUtilService } from '../../services/util/date-util.service';
import { useTranslations } from '../../hooks/use-translations.hook';
import { StringUtilService } from '../../services/util/string-util.service';
import { RollNumber } from '../RollNumber';

export const DateCountdown = ({
    className = '',
    fromDateTimestamp = Date.now(),
    tillDateTimestamp,
    countdownEndHandler = () => {},
}) => {
    const { t } = useTranslations();
    const [clockInterval, setClockInterval] = useState(null);
    const [dateParts, setDateParts] = useState(null);
    const [fromDateUpdated, setFromDateUpdated] = useState(fromDateTimestamp);

    const stopClock = () => {
        clearInterval(clockInterval);
    };

    // countdown timer
    useEffect(() => {
        if (fromDateUpdated) {
            const { difference } = DateUtilService.getTimeMeasure(fromDateUpdated, tillDateTimestamp);

            if (difference) {
                setClockInterval(setInterval(() => {
                    // add 1 sec to fromDate
                    setFromDateUpdated((prev) => (prev+1000));
                }, 1000));
            }

            return () => {
                stopClock();
            };
        }
    }, []);

    // update date parts data
    useEffect(() => {
        const datePartsUpdated = DateUtilService.getTimeMeasure(fromDateUpdated, tillDateTimestamp);
        setDateParts(datePartsUpdated);

        // signal that countdown ended
        if (datePartsUpdated.difference <= 0) {
            countdownEndHandler();
            stopClock();
        }
    }, [fromDateUpdated]);

    if (!dateParts) {
        return null;
    }

    const {
        seconds,
        minutes,
        hours,
        days,
    } = dateParts;

    // convert each number into set of rollin number components
    const showCountdownNumber = (num) => (<>{StringUtilService.padWithZero(num)
        .split('')
        .map((numPart, index) => (<RollNumber
            key={index}
            digit={numPart}
        />))}</>);

    return (
        <div className={`${className} asg-date-countdown`}>
            <div className="asg-date-countdown__date-part">
                <div className="asg-date-countdown__number">{showCountdownNumber(days)}</div>
                <div className="asg-date-countdown__number-desc">{t('stripDays')}</div>
            </div>
            <div className="asg-date-countdown__date-part">
                <div className="asg-date-countdown__number">{showCountdownNumber(hours)}</div>
                <div className="asg-date-countdown__number-desc">{t('stripHr')}</div>
            </div>
            <div className="asg-date-countdown__date-part">
                <div className="asg-date-countdown__number">{showCountdownNumber(minutes)}</div>
                <div className="asg-date-countdown__number-desc">{t('stripMin')}</div>
            </div>
            <div className="asg-date-countdown__date-part">
                <div className="asg-date-countdown__number">{showCountdownNumber(seconds)}</div>
                <div className="asg-date-countdown__number-desc">{t('stripSec')}</div>
            </div>
        </div>
    );
};
